module.exports = __webpack_public_path__ + "img/grt.c374f0d8.svg";